import Icon from "@/components/Icon";
import Menu from "@/components/Menu";
import Tag from "@/components/Tag";
import {
  getActiveBackendSource,
  getBackendSourceLabel,
  getBackendSourceMenuItems,
  isBackendSourceToggleAvailable
} from "@/lib/backendSource";

export default function BackendSourceIndicator() {
  if (!isBackendSourceToggleAvailable()) return null;

  const source = getActiveBackendSource();
  const label = getBackendSourceLabel(source);
  const isLocalhost = source === "localhost";

  return (
    <Menu
      menuItems={getBackendSourceMenuItems()}
      yOffset={8}
      title="API backend"
      AnchorComponent={
        <Tag
          size="small"
          compact
          tagType={isLocalhost ? "warn" : "information"}
          tagStyle="standard"
          iconName={isLocalhost ? "computer" : "cloud"}
          title={`API backend: ${label}`}
          testId="backend-source-indicator"
        >
          {label}
          <Icon name="expand_more" size={16} className="ml-1" />
        </Tag>
      }
    />
  );
}
